import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ReferralCrossPromo() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-20 bg-gradient-to-br from-[#FEF3C7] via-[#FDE68A] to-[#FEF3C7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`bg-white rounded-3xl shadow-2xl overflow-hidden transition-all duration-700 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
        >
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Left Side - Image */}
            <div className="relative h-56 sm:h-72 lg:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/9025629089756f5f69f2db03741ea203.jpg"
                alt="Friends celebrating together with a rescued dog"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent lg:bg-gradient-to-r"></div>
            </div>

            {/* Right Side - Content */}
            <div className="p-6 sm:p-8 md:p-12 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2 bg-[#E8B84B]/10 border border-[#E8B84B]/30 rounded-full px-4 py-2 mb-4 w-fit">
                <i className="ri-gift-line text-[#E8B84B]"></i>
                <span className="text-sm font-semibold text-[#1C2B1E]">Double the Impact</span>
              </div>

              <h2 className="font-oswald text-3xl sm:text-4xl md:text-5xl font-bold text-[#1C2B1E] mb-4">
                Refer a Friend,{' '}
                <span className="text-[#E8B84B]">Donate an Extra $100</span>
              </h2>

              <p className="text-base sm:text-lg text-[#4A5568] mb-5 leading-relaxed">
                When you refer someone who buys from us, we donate an <strong>additional $100</strong> to 
                Oregon Dog Rescue on top of our standard commitment. Plus, you can choose to donate 
                your $300 referral reward too—making it a <strong>$400 total donation</strong> per referral!
              </p>

              {/* Benefits List */}
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#4ADE80] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-[#1C2B1E] text-sm sm:text-base">
                    <strong>$300 reward</strong> for you (or donate it!)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#4ADE80] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-[#1C2B1E] text-sm sm:text-base">
                    <strong>$100 automatic donation</strong> from us
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#4ADE80] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-[#1C2B1E] text-sm sm:text-base">
                    <strong>$100 from their purchase</strong> (standard commitment)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#4ADE80] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-[#1C2B1E] text-sm sm:text-base">
                    Help your friends get a great deal
                  </span>
                </li>
              </ul>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/referral"
                  className="inline-flex items-center justify-center gap-2 bg-[#E8B84B] text-[#1C2B1E] px-6 py-3 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap shadow-lg hover:shadow-xl"
                >
                  <i className="ri-gift-line text-xl"></i>
                  Refer a Friend Now
                </Link>
                <Link
                  to="/inventory"
                  className="inline-flex items-center justify-center gap-2 bg-[#1C2B1E] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#2C3E55] transition-colors whitespace-nowrap"
                >
                  <i className="ri-car-line text-xl"></i>
                  Browse Inventory
                </Link>
              </div>

              {/* Small Print */}
              <p className="text-sm text-[#6B7280] mt-4">
                Referral reward paid after your friend's purchase is complete. You choose whether to keep it or donate it to Oregon Dog Rescue.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}